/**
 * The dotted line under words that lead somewhere: the document they open, or
 * the element they attach to. One line for both, so words that lead somewhere
 * read alike on every screen.
 */
export const LINK_MARK = "underline decoration-dotted underline-offset-2";

/** Where a thing is defined, underlined solid in the line colour: a term's source. */
export const SOURCE_LINK =
  "underline decoration-border underline-offset-2 hover:text-primary hover:decoration-current";

/**
 * A line of small print beneath the words it is about, in the lighter caption
 * colour: what a term is claimed as, or what an element attaches to.
 */
export const CAPTION_LINE = "text-[11px] text-subtle-foreground";

/**
 * A file's small facts in the mono face, beside or under its name: its page
 * count, or that it is deleted.
 */
export const FILE_META = "font-mono text-[11px] text-muted-foreground";
